import { classNames } from 'primereact/utils';

export function TabHeader(props: {
  activeTab: TabName;
  tab: TabName;
  setTab: (t: TabName) => void;
}) {
  return (
    <h4
      role="button"
      tabIndex={0}
      className={classNames({
        active: props.activeTab === props.tab,
      })}
      onClick={(e) => {
        e.stopPropagation();
        props.setTab(props.tab);
      }}
    >
      {props.tab}
    </h4>
  );
}
